<!-- Account Already Exists Dialog -->
<div id="st_signup_backdrop" class="st-dialog-backdrop" *ngIf="showAccountExistsDialog">
    <div id="st_signup_restricted_dialog" class="st-restricted-dialog p-4">
        <img alt="" src="assets/Account-exist.png" [attr.alt]="'account_already_exists' | translate"
            class="st-restricted-img" />
        <h5 class="st-restricted-title fs-18 fw-bold mb-2">{{ 'account_already_exists' | translate }}</h5>
        <p class="st-restricted-msg fs-13 fw-normal mb-0">{{ 'account_already_exists_msg' | translate }}<span
                *ngIf="footerSupportEmail" class="st-restricted-email fw-semibold"> ({{ footerSupportEmail }})</span>
        </p>
        <button class="st-restricted-btn fs-13 fw-semibold py-2 px-4" (click)="showAccountExistsDialog = false">{{
            'close' | translate }}</button>
    </div>
</div>

<div id="st_signup_container" class="login_container">
    <div id="st_signup_flex_container" class="flex-container d-flex flex-column"
        [ngClass]="_formGroupDynamic.get('password')?.value || total_fields.length > 4 || activeIndex != 0 ? 'refract-view' : ''">
        <div id="st_signup_bg_decor" class="auth-bg-decor" aria-hidden="true">
            <div class="auth-bg-glow"></div>
            <div class="auth-bg-dots"></div>
            <svg class="auth-bg-waves" viewBox="0 0 400 240" preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="authWaveGradientSignup1" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" class="auth-wave-stop-start-1" />
                        <stop offset="100%" class="auth-wave-stop-end" />
                    </linearGradient>
                    <linearGradient id="authWaveGradientSignup2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" class="auth-wave-stop-start-2" />
                        <stop offset="100%" class="auth-wave-stop-end" />
                    </linearGradient>
                    <linearGradient id="authWaveGradientSignup3" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" class="auth-wave-stop-start-3" />
                        <stop offset="100%" class="auth-wave-stop-end" />
                    </linearGradient>
                </defs>
                <path class="auth-wave-fill-1"
                    d="M-20 150 C 40 120, 90 170, 150 145 C 210 120, 260 165, 320 140 C 360 122, 390 132, 420 150 L 420 240 L -20 240 Z"
                    fill="url(#authWaveGradientSignup1)" />
                <path class="auth-wave-fill-2"
                    d="M-20 172 C 45 148, 95 190, 155 168 C 215 146, 265 185, 325 165 C 365 150, 392 158, 420 172 L 420 240 L -20 240 Z"
                    fill="url(#authWaveGradientSignup2)" />
                <path class="auth-wave-fill-3"
                    d="M-20 196 C 50 175, 100 210, 160 192 C 220 174, 270 208, 330 190 C 368 176, 394 182, 420 196 L 420 240 L -20 240 Z"
                    fill="url(#authWaveGradientSignup3)" />
                <path class="auth-wave-line"
                    d="M-20 168 C 45 144, 95 186, 155 164 C 215 142, 265 181, 325 161 C 365 146, 392 154, 420 168" />
                <path class="auth-wave-line auth-wave-line-2"
                    d="M-20 190 C 50 169, 100 204, 160 186 C 220 168, 270 202, 330 184 C 368 170, 394 176, 420 190" />
            </svg>
        </div>
        <div id="st_signup_brand_img" class="auth-wave-header" [class.collapsed-header]="total_fields.length >= 3 && activeIndex != 1">
            <div class="brand_img">
                <img *ngIf="!is_dark" [src]="loginSidebarLogoLight" alt="logo_dark"
                    [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
                <img *ngIf="is_dark" [src]="logo_light" alt="logo_dark"
                    [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
            </div>
            <button type="button" class="auth-close-btn" (click)="closeDialog()"
                [attr.aria-label]="'close' | translate">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>
        <div id="st_signup_company_detail_0" class="company_detail" *ngIf="activeIndex == 0">
            <div id="st_signup_login_box_0" class="login_box">
                <p class="login-welcome-title fs-32 fw-bold mb-0">
                    {{ 'signup_title' | translate }} <span class="login-welcome-accent">{{ 'signup_title_accent' |
                        translate }}</span>
                </p>
                <p class="login-welcome-subtitle fs-14 fw-normal mt-1 mb-4">{{ 'signup_subtitle' | translate }}</p>
                <div id="st_signup_role_dropdown" class="role st-login-dropdown"
                    [ngClass]="_selectedRole == null ? 'not_selected' : ''">
                    <p class="fs-13 fw-medium">{{ 'role' | translate }}</p>
                    <p-dropdown [options]="all_roles" [(ngModel)]="_selectedRole" optionLabel="name"
                        [ngModelOptions]="{ standalone: true }" (onChange)="GetRoleFieldsOnId($event)"
                        [placeholder]="'selectRole' | translate" [filter]="true" filterBy="name"
                        [resetFilterOnHide]="true" [autofocusFilter]="true" [filterPlaceholder]="'search' | translate"
                        [appendTo]="'body'" panelStyleClass="st-role-dropdown-panel" />
                </div>
                <div id="st_signup_box_detail" class="box_detail" [formGroup]="_formGroupDynamic">
                    <div [id]="'st_signup_email_wrapper' + i" class="email st_signup_user_defined_fields"
                        *ngFor="let item of total_fields ;let i=index; trackBy: trackByFieldId">
                        <div [id]="'st_signup_text_wrap' + i" *ngIf="item.field.type=='text'">
                            <mat-label [id]="'st_signup_text_label' + i">{{item.field.name|translate}}</mat-label>
                            <input id="st_signup" class="full_width_input" [type]="item.field.type"
                                [formControlName]="item.field_id" />
                        </div>
                        <div [id]="'st_signup_email_wrap' + i" *ngIf="item.field.type=='email'">
                            <mat-label [id]="'st_signup_email_label' + i">{{item.field.name|translate}}</mat-label>
                            <input id="st_signup-2" class="full_width_input" [type]="item.field.type"
                                [formControlName]="item.field_id" [(ngModel)]="emailValue"
                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}"
                                placeholder="{{ 'example_email_com' | translate }}" />
                        </div>

                        <div [id]="'st_signup_alphanum_wrap' + i" *ngIf=" item.field.type=='alphanum'">
                            <mat-label [id]="'st_signup_alphanum_label' + i">{{item.field.name}} <sup
                                    *ngIf="item?.is_required" class="text-danger">*</sup></mat-label>
                            <input id="st_signup-3" matInput class="full_width_input" type="text"
                                [formControlName]="item.field_id" pattern="[a-zA-Z0-9]*"
                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}" />
                        </div>
                        <div [id]="'st_signup_date_wrap' + i" *ngIf="item.field.type=='date'">
                            <mat-label [id]="'st_signup_date_label' + i">{{item.field.name}}<sup
                                    *ngIf="item?.is_required" class="text-danger">*</sup></mat-label>
                            <input id="st_signup-4" matInput class="full_width_input" type="date"
                                [formControlName]="item.field_id"
                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}" />
                        </div>
                        <div [id]="'st_signup_password_wrap' + i" *ngIf="item.field.type=='password'">
                            <mat-label [id]="'st_signup_password_label' + i">{{item.field.name| translate}}</mat-label>
                            <div [id]="'st_signup_password_field' + i" class="st-password-field position-relative">
                                <input id="st_signup-5" class="full_width_input " #input
                                    [type]="item.show_password?'text':'password'" [formControlName]="item.field_id"
                                    [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required'), 'criteria-attached-field': _formGroupDynamic.get('password')?.value && item.field.name == 'Password'}"
                                    [placeholder]="'Password'|translate" />

                                <button type="button" class="st-btn-unstyled"
                                    (click)="showPassword(input.type,i)"><i
                                        [ngClass]="{'bi-eye-slash':item.show_password,'bi-eye-fill':!item.show_password}"
                                        class="bi fs-14 st-pointer position-absolute"></i></button>


                            </div>

                            <!-- Password Criteria List for password field -->
                            <div [id]="'st_signup_password_input' + i" class="password_input"
                                *ngIf="item.field_id === 'password' && _formGroupDynamic.get('password')?.value">
                                <div [id]="'st_signup_password_criteria' + i" class="password-criteria">
                                    <ul class="criteria-list">
                                        <li class="d-flex align-items-center gap-1 fs-12"
                                            [class.criteria-met]="isPasswordUppercaseValid()"
                                            [class.criteria-not-met]="!isPasswordUppercaseValid()">
                                            <i class="bi fs-13"
                                                [class.bi-check-circle-fill]="isPasswordUppercaseValid()"
                                                [class.bi-x-circle-fill]="!isPasswordUppercaseValid()"></i>
                                            <!-- {{'At_least_one_uppercase'|translate}} -->
                                            {{'A-Z'}}
                                        </li>
                                        <li class="d-flex align-items-center gap-1 fs-12"
                                            [class.criteria-met]="isPasswordNumberValid()"
                                            [class.criteria-not-met]="!isPasswordNumberValid()">
                                            <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordNumberValid()"
                                                [class.bi-x-circle-fill]="!isPasswordNumberValid()"></i>
                                            <!-- {{'At_least_one_numeric' |translate}} -->
                                            {{'0-9'}}
                                        </li>
                                        <li class="d-flex align-items-center gap-1 fs-12"
                                            [class.criteria-met]="isPasswordSpecialValid()"
                                            [class.criteria-not-met]="!isPasswordSpecialValid()">
                                            <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordSpecialValid()"
                                                [class.bi-x-circle-fill]="!isPasswordSpecialValid()"></i>
                                            <!-- {{'at_least_one_special_character'|translate}} -->
                                            {{'@#$%'}}
                                        </li>
                                        <li class="d-flex align-items-center gap-1 fs-12"
                                            [class.criteria-met]="isPasswordLengthValid()"
                                            [class.criteria-not-met]="!isPasswordLengthValid()">
                                            <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordLengthValid()"
                                                [class.bi-x-circle-fill]="!isPasswordLengthValid()"></i>
                                            <!-- {{'Minimum_8_characters'| translate}} -->
                                            {{'8+ chars'}}
                                        </li>
                                    </ul>
                                    <p class="text-muted fs-12 mt-1 fw-medium">{{'example'|translate}}: {{'Test@1234'}}
                                    </p>
                                </div>
                            </div>

                            <!-- Password Match Validation for confirm password field -->
                            <div [id]="'st_signup_conf_password_input' + i" class="password_input"
                                *ngIf="item.field_id === 'Confirm_password' && _formGroupDynamic.get('Confirm_password')?.value">
                                <div [id]="'st_signup_password_match' + i" class="password-match mt-2">
                                    <div [id]="'st_signup_password_match_ind' + i"
                                        [class.criteria-met]="isPasswordMatch()"
                                        [class.criteria-not-met]="!isPasswordMatch()"
                                        class="match-indicator d-flex align-items-center gap-1 fs-12">
                                        <i class="bi fs-13" [class.bi-check-circle-fill]="isPasswordMatch()"
                                            [class.bi-x-circle-fill]="!isPasswordMatch()"></i>
                                        {{ isPasswordMatch() ? ('password_match' | translate) : ('password_do_not_match'
                                        | translate) }}
                                    </div>
                                </div>
                            </div>

                            <div [id]="'st_signup_password_err' + i" class="error-txt-msg fs-11 mb-2"
                                *ngIf="_isSubmit && !check_password() && item.id=='Confirm_password'"
                                style="color: red">
                                {{'new_and_confirm_password_should_be_different' | translate}}</div>

                        </div>
                        <div [id]="'st_signup_dropdown_wrap' + i" class="mt-3" *ngIf="item.field.type=='dropdown'">
                            <mat-label [id]="'st_signup_dropdown_label' + i">{{item.field.name}}<sup
                                    *ngIf="item?.is_required" class="text-danger">*</sup></mat-label>
                            <mat-select id="st-signup-fullwidthinput" *ngIf="item.is_multi_valued" multiple
                                class="full_width_input" panelClass="st-signup-mat-select-panel"
                                [formControlName]="item.field_id"
                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}">
                                @for (option of item.field.value_json|keyvalue; track option) {
                                <mat-option [id]="'st_signup_dropdown_multi_opt' + (option.value)"
                                    [value]="option.value">{{option.value}}</mat-option>
                                }
                            </mat-select>
                            <mat-select id="st-signup-fullwidthinput-5" *ngIf="!item.is_multi_valued"
                                class="full_width_input" panelClass="st-signup-mat-select-panel"
                                [formControlName]="item.field_id"
                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}">
                                @for (option of item.field.value_json|keyvalue; track option) {
                                <mat-option [id]="'st_signup_dropdown_single_opt' + (option.value)"
                                    [value]="option.value">{{option.value}}</mat-option>
                                }
                            </mat-select>
                        </div>
                        <div [id]="'st_signup_file_wrap' + i" class="bannerSection st-transparent-fields"
                            *ngIf="item.field.type=='file'">
                            <mat-label [id]="'st_signup_file_label' + i">{{item.field.name}}<sup
                                    *ngIf="item?.is_required" class="text-danger">*</sup></mat-label>
                            <div [id]="'st_signup_banner_flex' + i" class="bannerFlex" *ngIf="item.dummy_value === ''">
                                <div [id]="'st_signup_banner_box' + i" class="bannerBox _dashed">
                                    <input (change)="fileDetail($any($event.target).files,item.field_id,i)"
                                        class="full_width_input fileUploader" type="file"
                                        [formControlName]="item.field_id"
                                        [accept]="getAcceptType(item.field.value_json.data0)"
                                        [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}" />

                                    <div [id]="'st_signup_overlap' + i" class="overlap">
                                        <div [id]="'st_signup_flex_hc' + i" class="flex-hc mb-3">
                                            <div [id]="'st_signup_info' + i" class="info">
                                                <div [id]="'st_signup_choose' + i" class="choose">
                                                    <p class="p-secondary-dark">
                                                    </p>
                                                </div>
                                                <p class="p-secondary">
                                                    <b></b>
                                                </p>
                                            </div>
                                            <div [id]="'st_signup_img_container' + i" class="imgContainer"
                                                *ngIf="false">
                                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="31.5981" cy="32.3867" r="31.5" fill="white" />
                                                    <path
                                                        d="M30.5629 44.0704V35.1972H21.6897V32.2394H30.5629V23.3662H33.5207V32.2394H42.3939V35.1972H33.5207V44.0704H30.5629Z"
                                                        fill="#4E4E4E" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div [id]="'st_signup_box' + i" class="box">
                                            <p class="st-headerSelected-clr">
                                                {{ 'upload_from' | translate }} <span>{{ 'device' | translate }}
                                                </span>/ {{ 'drag_n_drop' | translate }}
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div [id]="'st_signup_dummy_val_wrap' + i" *ngIf="item.dummy_value != ''">
                                
                                

                                <div [id]="'st_signup_d_flex_group' + i" class="d-flex gap-2">
                                    <input class="full_width_input" type="email" disabled
                                        placeholder="{{'uploaded_successfully'| translate}}"
                                        [ngClass]="item.dummy_value != '' ?'success':''" />
                                    <div [id]="'st_signup_d_flex_group_align' + i"
                                        class="d-flex gap-2 align-items-center">
                                        <button type="button" class="st-btn-unstyled"
                                            (click)="openImageInNewTab(item.dummy_value)"><i
                                                class="bi bi-eye pe-3 st-pointer"></i></button>
                                        <i class="st-pointer bi bi-upload position-relative" *ngIf="!is_view">
                                            <input type="file"
                                                (change)="fileDetail($any($event.target).files,item.field_id,i)" name=""
                                                [accept]="getAcceptType(item.field.value_json.data0)" id="upload">
                                        </i>
                                    </div>
                                </div>
                            </div>
                            <div [id]="'st_signup_banner_box_false' + i" class="bannerBox" *ngIf="false">
                                <div [id]="'st_signup_relative_body' + i" class="relativeBody">
                                    <input type="image" class="imgCover img-fluid"
                                        [src]="_formGroupDynamic.controls[item.field_id].value" alt="" />
                                    <div [id]="'st_signup_inner_color' + i" class="innerColor">
                                        

                                        <div [id]="'st_signup_reupload_boxie' + i" class="reuploadBoxie">
                                            <input id="option-1"
                                                (change)="fileDetail($any($event.target).files,item.field_id,i)"
                                                class="full_width_input" type="file" class="fileUploader"
                                                [formControlName]="item.field_id"
                                                [accept]="getAcceptType(item.field.value_json.data0)"
                                                [ngClass]="{'st-invalid-shake':_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')}" />
                                            <label for="option-1">
                                                <div [id]="'st_signup_uploadbtn' + i" class="uploadbtn">{{'reupload' |
                                                    translate}}</div>
                                                <div [id]="'st_signup_pi_cloud' + i" class="pi pi-cloud-upload"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div [id]="'st_signup_req_err' + i" class="error-txt-msg fs-11 mb-2 mt-0"
                            *ngIf=" _isSubmit && _formGroupDynamic.controls[item.field_id].hasError('required')"
                            style="color: red;"> <span style="color: red">*</span>{{'required' | translate}}
                        </div>
                        <div [id]="'st_signup_pattern_err' + i" class="error-txt-msg fs-11 mb-2"
                            *ngIf="_isSubmit && _formGroupDynamic.controls[item.field_id].hasError('pattern')"
                            style="color: red">
                            Incorrect Format.</div>

                    </div>

                </div>
                

                <div id="st_signup_btn_wrapper" class="mt-3 flex-vc flex-column">
                    <button *ngIf="false" class="pro_but flex-hc flex-vc gap-2 proceed_but">{{'register'|translate}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-caret-right-fill" viewBox="0 0 16 16">
                            <path
                                d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg></button>
                    <!-- Terms checkbox: show only if terms URL is configured and a role is selected -->
                    <div id="st_signup_terms" *ngIf="globalTermsUrl && _selectedRole" class="terms mt-2 w-100">
                        <label class="d-flex align-items-center" style="cursor: pointer;">
                            <input type="checkbox" class="small-checkbox me-1" style="accent-color:var(--auth-accent);"
                                (change)="acceptedTerms = $any($event.target).checked" />
                            <span class="ms-2 fs-12 fw-normal">
                                {{ 'by_signing_in_you_agree_to_the' | translate }}
                                <a [href]="globalTermsUrl || '#'" target="_blank" rel="noopener noreferrer"
                                    class="ms-1 fw-medium">
                                    {{ 'terms_and_conditions' | translate }}
                                </a>
                            </span>
                        </label>
                    </div>

                    <button id="login_proceed_button" type="submit"
                        class="flex-hc flex-vc gap-2 fs-14 fw-semibold proceed_but mt-2" [disabled]="isSignupDisabled"
                        [ngClass]="{
                          'disable_login_btn': valid_form || !_selectedRole || isSignupDisabled,
                          'st-disableBtn': _formGroupDynamic.invalid && valid_form
                        }" (click)="signUpOtp()" (keydown.enter)="signUpOtp()" (keydown.space)="$event.preventDefault(); signUpOtp()" tabindex="0">
                        {{ 'signUp' | translate }}
                    </button>
                    
                </div>
                <div id="st_signup_bottom_section" class="bottom_section" (click)="navigateToFrgt()"
                    (keydown.enter)="navigateToFrgt()"
                    (keydown.space)="$event.preventDefault(); navigateToFrgt()" tabindex="0">
                    <p class=" text-nowrap fs-13 fw-semibold">{{'Already_have_an_account?'| translate}} <a
                            id="st_signup_login_text" class="st-primary-color fw-medium" style="cursor: pointer;">{{
                            'login' | translate }}</a></p>
                </div>
            </div>
        </div>
        <div id="st_signup_company_detail_1" class="company_detail" *ngIf="activeIndex == 1">
            <div id="st_signup_login_box_1" class="login_box">
                <p class="login-welcome-title fs-32 fw-bold mb-0">
                    {{ 'verify_email_title' | translate }} <span class="login-welcome-accent">{{ 'verify_email_title_accent' | translate }}</span>
                </p>
                <p class="login-welcome-subtitle fs-14 fw-normal mt-1 mb-4">{{ 'verify_email_subtitle' | translate }}</p>
                <div id="st_signup_otp_wrapper">
                    <div id="otpinputs" class="my-4">
                        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"
                            inputClass="otpFixed">
                        </ng-otp-input>
                    </div>

                    <!-- OTP inline info banner -->
                    <div id="st_signup_otp_timer_wrap"
                      class="otp-info-banner mb-3"
                      [class.otp-info-banner--warning]="isOtpCountdownActive() && timer <= 30"
                      [class.otp-info-banner--expired]="isOtpExpired()"
                      [class.otp-info-banner--resending]="_isResendingOtp"
                      *ngIf="_startCountdown || _isResendingOtp">
                      @if (isOtpExpired()) {
                      <div class="otp-info-banner__expired d-flex align-items-start justify-content-between gap-3">
                        <div class="d-flex align-items-start gap-2 min-w-0">
                          <span class="otp-info-banner__icon-wrap otp-info-banner__icon-wrap--expired" aria-hidden="true">
                            <i class="bi bi-exclamation-circle otp-info-banner__icon otp-info-banner__icon--expired"></i>
                          </span>
                          <div class="min-w-0">
                            <p class="mb-0 fs-14 fw-semibold otp-info-banner__expired-title">
                              {{ 'otp_verification_code_expired' | translate }}
                            </p>
                            <p class="mb-0 fs-13 otp-info-banner__expired-message">
                              {{ 'otp_expired_support_message' | translate }}
                            </p>
                          </div>
                        </div>

                        <button type="button" id="otpSender"
                          class="otp-info-banner__resend fs-13 fw-medium flex-shrink-0 d-inline-flex align-items-center gap-1"
                          [disabled]="_isResendingOtp"
                          (click)="resendSignupOtp()"
                          [attr.aria-label]="'resend_now' | translate">
                          @if (_isResendingOtp) {
                          <span class="otp-info-banner__spinner otp-info-banner__spinner--inline" aria-hidden="true"></span>
                          <span>{{ 'otp_resending' | translate }}</span>
                          } @else {
                          <i class="bi bi-arrow-repeat otp-info-banner__resend-icon" aria-hidden="true"></i>
                          <span>{{ 'resend_now' | translate }}</span>
                          }
                        </button>
                      </div>
                      } @else {
                      <div class="otp-info-banner__body d-flex flex-column">
                        <div class="otp-info-banner__head d-flex align-items-start gap-2 min-w-0">
                          <span class="otp-info-banner__icon-wrap" aria-hidden="true">
                            <i class="bi bi-envelope otp-info-banner__icon"></i>
                          </span>
                          <div class="min-w-0">
                            <p class="mb-0 fs-14 fw-medium otp-info-banner__title">
                              {{ 'otp_verification_sent_title' | translate }}
                            </p>
                            <p class="mb-0 fs-13 otp-info-banner__email text-truncate">
                              {{ 'otp_delivered_to' | translate }} {{ getMaskedEmail() }}
                            </p>
                          </div>
                        </div>

                        <div class="otp-info-banner__utility d-flex align-items-center justify-content-between gap-2 min-w-0 mt-1">
                          <div class="d-flex align-items-center gap-2 min-w-0">
                            @if (_isResendingOtp) {
                            <span class="otp-info-banner__spinner" aria-hidden="true"></span>
                            <span class="fs-13 fw-medium otp-info-banner__timer">{{ 'otp_sending_new_code' | translate }}</span>
                            } @else {
                            <span class="otp-info-banner__icon-wrap otp-info-banner__icon-wrap--utility" aria-hidden="true">
                              <i class="bi bi-clock otp-info-banner__icon"></i>
                            </span>
                            <span class="fs-13 fw-medium otp-info-banner__timer">
                              <span class="otp-info-banner__timer-label">{{ 'otp_expires_in' | translate }}</span>
                              <span class="otp-info-banner__timer-value fw-bold">{{ formatOtpTimer() }}</span>
                            </span>
                            }
                          </div>

                          <button type="button" id="otpSender"
                            class="otp-info-banner__resend fs-13 fw-medium flex-shrink-0 d-inline-flex align-items-center gap-1"
                            [disabled]="_isResendingOtp"
                            (click)="resendSignupOtp()"
                            [attr.aria-label]="'resend_now' | translate">
                            @if (_isResendingOtp) {
                            <span class="otp-info-banner__spinner otp-info-banner__spinner--inline" aria-hidden="true"></span>
                            <span>{{ 'otp_resending' | translate }}</span>
                            } @else {
                            <i class="bi bi-arrow-repeat otp-info-banner__resend-icon" aria-hidden="true"></i>
                            <span>{{ 'resend_now' | translate }}</span>
                            }
                          </button>
                        </div>

                        <div class="otp-info-banner__track" role="progressbar"
                          [attr.aria-valuenow]="timer"
                          [attr.aria-valuemin]="0"
                          [attr.aria-valuemax]="otpTimerDuration"
                          [attr.aria-label]="('otp_expires_in' | translate) + ' ' + formatOtpTimer()">
                          <div class="otp-info-banner__progress"
                            [class.otp-info-banner__progress--loading]="_isResendingOtp"
                            [style.width.%]="getOtpTimerProgress()"></div>
                        </div>
                      </div>
                      }
                    </div>
                </div>
                <div id="st_signup_otp_btn_wrap" class="mt-4 d-flex justify-content-between" *ngIf="activeIndex == 1">
                    <button type="button" class="send_btn fs-13 fw-semibold py-2 px-4 text-capitalize"
                        (click)="verifyOtpSignup()" [disabled]="_currentOTP.length != 6">
                        {{ 'Verify_OTP_Full' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>